<div class="container-fluid">
  <div class="container">
    <div class="row">
      <nav class="navbar navbar-expand-lg navbar-light navbar-tp" id="myLinks">
        <a class="navbar-brand" class="logo"
          [routerLink]="selectedLanguage.code === 'en' ? '/' : '/' + selectedLanguage.code ">
          <img class="img-fluid logo mt-2" src="../../assets/images/grammarin-logo/grammarin-logo.svg"
            style="cursor: pointer; width: auto" alt="logo-main" />
        </a>
        <!-- (click)="grouteto()"  -->
        <button class="navbar-toggler heradericon mt-2" type="button" data-toggle="collapse"
          data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
          aria-label="Toggle navigation" style="border: none" id="navopen">
          <!-- <span class="navbar-toggler-icon"></span> --><span><img src="/../../assets/images/headericon.svg"
              alt="headericon" width="34px" height="34px" /></span>
        </button>

        <div class="collapse navbar-collapse margn" id="navbarSupportedContent" #navbarContent>
          <ul class="navbar-nav mr-auto mx-auto mt-4" id="navbar-nav">
            <li class="d-md-none d-block" style="cursor: pointer; ">
              <!-- <button
                class="closebtn btn custom-close-button"
                (click)="closeNav()"
                aria-label="Close navigation"
                style="border: none"
              >
                &times;
              </button> -->
              <button *ngIf="activeDropdown === 'tools'" class="closebtn btn custom-close-button"
                (click)="toggleDropdowns('tools')" aria-label="Close navigation" style="border: none">
                &times;
              </button>
            </li>
            <li class="nav-item dropdown" id="nav-item ">
              <button class="btn nav-btn" id="navbarDropdown" role="button" data-toggle="dropdown" aria-expanded="false"
                (click)="toggleDropdowns('tools')"
                style=" width: max-content; display: flex;gap: 0.3rem;align-items: center;">
                {{ "header.ALL_TOOLS" | translate }}<app-icons-free-tools name="Toggleiconheader" />
              </button>
              <div class="dropdown-menu list-header p-1" [ngClass]="{ show: activeDropdown === 'tools' }"
                style="float: right" aria-labelledby="navbarDropdown ">
                <div class="row row pb-3 drop-tool">
                  <div class="col">
                    <a class="dropdown-item" style="margin-top: 15px !important" [routerLink]="['/grammar-checker']">
                      <!-- [routerLink]="selectedLanguage.code === 'en' ? '/grammar-checker' : '/' + selectedLanguage.code + '/grammar-checker'" -->
                      <app-icons-free-tools name="arrowToggleiconheader" />

                      <span class="submenu_text">{{ "header.GRAMMAR_CHECKER" | translate }}</span>
                    </a>
                    <hr class="dropdown-divider ms-4 hr" style="width: 252px" />
                    <a class="dropdown-item" [routerLink]="['/punctuation-checker']">
                      <app-icons-free-tools name="arrowToggleiconheader" />
                      <span class="submenu_text">{{ "header.PUNCTUATION_CHECKER" | translate }}</span>
                    </a>

                    <hr class="dropdown-divider ms-4 hr" style="width: 252px" />
                    <a class="dropdown-item" [routerLink]="['/ai-content-detector']">
                      <!-- (click)="AICroute()"  -->
                      <app-icons-free-tools name="arrowToggleiconheader" />
                      <span class="submenu_text">{{ "header.AI_TEXT_DETECTOR" | translate }}</span>
                    </a>
                  </div>

                  <div class="col">
                    <a class="dropdown-item plag" style="margin-top: 15px" [routerLink]="['/plagiarism-checker']">
                      <app-icons-free-tools name="arrowToggleiconheader" />
                      <span class="submenu_text">{{ "header.PLAGIARISM_CHECKER" | translate }}</span>
                    </a>
                    <hr class="dropdown-divider ms-4 hr" style="width: 252px" />
                    <a class="dropdown-item" [routerLink]="['/paraphrasing-tool']">
                      <app-icons-free-tools name="arrowToggleiconheader" />
                      <span class="submenu_text">{{ "header.PARAPHRASING_TOOL" | translate }}</span>
                    </a>
                    <hr class="dropdown-divider ms-4 hr" style="width: 252px" />

                    <a class="dropdown-item" [routerLink]="['/text-summarizer']">
                      <app-icons-free-tools name="arrowToggleiconheader" />
                      <span class="submenu_text">{{ "header.TEXT_SUMMARIZER" | translate }}</span>
                    </a>
                  </div>

                  <div class="col" style="
                      display: flex;

                      align-items: center;
                      text-align: center;
                      justify-content: center;
                      flex-direction: column;
                    ">
                    <hr class="dropdown-divider ms-4 hr" style="width: 252px" />
                    <div>
                      <a class="dropdown-item" [routerLink]="['/ai-writing-tools']">
                        <app-icons-free-tools name="arrowToggleiconheader" />
                        <span class="submenu_text">{{ "header.AI_WRITING_TOOLS" | translate }}</span>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="row row drop-tool-phone">
                  <a class="dropdown-item" style="margin-top: 15px !important" [routerLink]="['/grammar-checker']">
                    <!-- [routerLink]="selectedLanguage.code === 'en' ? '/grammar-checker' : '/' + selectedLanguage.code + '/grammar-checker'" -->
                    <app-icons-free-tools name="arrowToggleiconheader" />
                    <span class="submenu_text">{{ "header.GRAMMAR_CHECKER" | translate }}</span>
                  </a>
                  <hr class="dropdown-divider hr" style="margin-left: 25px; width: 191px" />

                  <a class="dropdown-item" [routerLink]="['/plagiarism-checker']">
                    <app-icons-free-tools name="arrowToggleiconheader" />
                    <span class="submenu_text">{{ "header.PLAGIARISM_CHECKER" | translate }}</span>
                  </a>
                  <hr class="dropdown-divider hr" style="margin-left: 25px; width: 191px" />
                  <a class="dropdown-item" [routerLink]="['/punctuation-checker']">
                    <app-icons-free-tools name="arrowToggleiconheader" />
                    <span class="submenu_text">{{ "header.PUNCTUATION_CHECKER" | translate }}</span>
                  </a>

                  <hr class="dropdown-divider hr" style="margin-left: 25px; width: 191px" />
                  <a class="dropdown-item" [routerLink]="['/paraphrasing-tool']">
                    <app-icons-free-tools name="arrowToggleiconheader" />
                    <span class="submenu_text">{{ "header.PARAPHRASING_TOOL" | translate }}</span>
                  </a>

                  <hr class="dropdown-divider hr" style="margin-left: 25px; width: 191px" />
                  <a class="dropdown-item" [routerLink]="['/ai-content-detector']">
                    <app-icons-free-tools name="arrowToggleiconheader" />
                    <span class="submenu_text">{{ "header.AI_TEXT_DETECTOR" | translate }}</span>
                  </a>
                  <a class="dropdown-item" [routerLink]="['/text-summarizer']">
                    <app-icons-free-tools name="arrowToggleiconheader" />
                    <span class="submenu_text">{{ "header.TEXT_SUMMARIZER" | translate }}</span>
                  </a>

                  <a class="dropdown-item" [routerLink]="['/ai-writing-tools']">
                    <app-icons-free-tools name="arrowToggleiconheader" />
                    <span class="submenu_text">{{ "header.AI_WRITING_TOOLS" | translate }}</span>
                  </a>
                </div>
              </div>
            </li>
            <hr class="d-md-none d-block" style="margin-top: 0px" />
            <li class="nav-item">
              <a class="nav-link" style="cursor: pointer;   width: max-content;" [routerLink]="['/grammar-checker']">
                <!-- [routerLink]="selectedLanguage.code === 'en' ? '/grammar-checker' : '/' + selectedLanguage.code + '/grammar-checker'" -->
                {{ "header.GRAMMAR_CHECKER" | translate }}
              </a>
            </li>
            <hr class="d-md-none d-block" style="margin-top: 0px" />
            <li class="nav-item">
              <a class="nav-link" style="cursor: pointer" [routerLink]="['/contact-us']">
                {{ "header.Contact" | translate }}
              </a>
            </li>

            <hr class="d-md-none d-block" style="margin-top: 0px" />
            <li class="nav-item">
              <a class="nav-link" style="cursor: pointer" [routerLink]="premium_user ? '/accountsettings' : '/pricing'"
                [queryParams]="premium_user ? { ref: 'premium' } : null">
                {{ "header.Pricing" | translate }}
              </a>
            </li>

            <hr class="d-md-none d-block" style="margin-top: 0px" />
            <li class="nav-item dropdown" *ngIf="!isLoading">
              <a class="nav-link" *ngIf="!checkLogin" style="cursor: pointer" [routerLink]="['/signin']" id="signin">{{
                "header.Login" | translate }}
              </a>
            </li>
            <hr *ngIf="!isLoading" class="d-md-none d-block" style="margin-top: 0px" />
            <!-- <li class="nav-item dropdown">
              <button class="btn nav-btn dpdn" id="navbarDropdown" (click)="toggleDropdown()"
                (click)="toggleDropdowns('languages')">
                <img [src]="selectedLanguage.icon" class="" alt="language" width="24px" height="24px" />
                {{ selectedLanguage.name }}
              </button>
            </li> -->



            <li class="nav-item language " id="nav-item ">
              <div class="ms-auto">
                <button class="btn nav-btn p-0 pl-2 d-flex " type="button" data-toggle="dropdown"
                  style="align-items: center; " role="button" data-toggle="dropdown" aria-expanded="false"
                  id="navbarDropdownLanguages" style="display: flex; align-items: center; gap: 0.2rem;     font-size: 16px;
                  font-weight: 500;" (click)="toggleDropdowns('languages')">

                  <img [src]="selectedLanguage.icon" class="" alt="language" width="24px" height="24px" />
                  {{ selectedLanguage.name }}
                  <!-- <app-icons-free-tools name="dropdownIcon" class="drop-icon"
                    [hidden]="!shouldShowLanguageDropdown()" /> -->

                </button>
                <!-- <ul class="dropdown-menu pt-0 pb-1 " [ngClass]="{ show: activeDropdown === 'languages' }"
                  id="list-languages" *ngIf="shouldShowLanguageDropdown()" aria-labelledby="navbarDropdownLanguages">
                  <li class="mb-1  p-2 bordr" style="
                               
                                  border-top-left-radius: 8px;
                                  border-top-right-radius: 8px;
                                ">
                    <a *ngFor="let lang of languages" class="dropdown-item  hover" href="javascript:void(0)"
                      (click)="selectLanguage(lang)" style="display: flex; gap: 0.5rem; align-items: center;">
                      <img [src]="lang.icon" alt="drop-img" class="flag " />
                      <span class="lang-names">{{ lang.name }}</span> </a>
                  </li>

                </ul> -->
              </div>
            </li>

            <li class="nav-item">
              <div class="ms-auto">
                <button (click)="toggleDropdowns('user')" *ngIf="checkLogin"
                  class="btns dropmenu dropdown-toggle p-0 pl-2 d-flex " type="button" data-toggle="dropdown"
                  id="userDropdownButton">
            <li class="nav-item df-alcenter" *ngIf="checkLogin" style="display: flex">
              <span class="user_img_sec">
                <img class="img-fluid" src="../../assets/images/tool/user-male.svg" alt="user-male" width="40px"
                  height="40px" />
              </span>
              <span class="caret"></span>
            </li>
            </button>
            <ul class="dropdown-menu pt-0 pb-1 phone" [ngClass]="{ show: activeDropdown === 'user' }" id="list"
              #useContent>
              <li class="mb-1 d-flex p-2 bordr" style="
                      background: #f3f8fc;
                      border-top-left-radius: 8px;
                      border-top-right-radius: 8px;
                    ">
                <div class="img ms-2">
                  <img class="img-fluid" src="../../assets/images/tool/user-male.svg" alt="user-male" class=""
                    width="40px" height="40px" />
                </div>
                <a class="dropdown-item li" disabled="" id="user_name">
                  <div class="" style>
                    <span>{{ firstName | titlecase }}</span>
                  </div>
                </a>
              </li>
              <li>
                <a class="dropdown-item ms-2 li">
                  <app-icons-free-tools name="gotodashboardiconheader" />
                  <span class="submenu_text" style="font-weight: 400; font-size: 16px" (click)="navigatetoopenfile()">{{
                    "header.GotoDashboard" | translate }}</span>
                </a>
              </li>
              <li>
                <a class="dropdown-item ms-2 li">
                  <span class="submenu_icon settings_icon"><app-icons-free-tools
                      name="accountsettingiconheader" /></span>
                  <span class="submenu_text" style="font-weight: 400; font-size: 16px" target="_blank"
                    (click)="routetoaccountsetting()">{{ "header.AccountSettings" | translate }}</span>
                </a>
              </li>
              <li>
                <a class="dropdown-item ms-2 li" (click)="logout()">
                  <span class="submenu_icon logout_icon"><app-icons-free-tools name="logouticonheader" /></span>
                  <span class="submenu_text" style="font-weight: 400; font-size: 16px">
                    {{ "header.Logout" | translate }}</span>
                </a>
              </li>
            </ul>
        </div>
        </li>
        </ul>
    </div>
    </nav>
  </div>
</div>
</div>